/**
 * @desc 根据categroyNos查询品类
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyResponseDtoRpc>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/productCategroy/getByCategroyNos`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
